<template>
  <div class="chikoku">
    <h3>遅刻申請</h3>
    <div class="col-item">
      <b class="title">月日</b>
      <p>{{ chikoku?.start_date }}</p>
    </div>

    <div class="col-item">
      <b class="title">就業場所</b>
      <p>{{ form.syuugyou_basyo_name }}</p>
    </div>

    <div class="col-item">
      <b class="title">出勤時刻</b>
      <p>{{ chikoku?.start_time }}</p>
    </div>

    <div class="col-item">
      <b class="title">遅刻事由</b>
      <p class="pre">{{ form.shinsei_jiyuu }}</p>
    </div>

    <div class="col-item">
      <b class="title">備考</b>
      <p class="pre">{{ form.notes ?? '無し' }}</p>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import { dateFormat, timeFormat } from "@/filters/common";
import dayjs from 'dayjs'
import { Shinsei } from '@/types/Shinsei';

export default defineComponent({
  props: {
    form: {
      type: Object as () => Shinsei,
      default: null
    },
  },
  setup(props) {

    const chikoku = props.form.chikoku;

    const timeFormater = (val?: string | null) => {
      if (!val) {
        return
      }
      const date = dayjs().format('YYYY-MM-DD') + ' ' + val
      return timeFormat(date)
    }

    return {
      chikoku,
      dateFormat,
      timeFormater
    }
  },
  components: {

  }
})

</script>
<style lang="scss" scoped>
@import '@scss/components/shinsei-detail.scss';
</style>
